import { useContext } from "react";
import { MemberEligibilityContext } from "@/App/context";
import { useListMemberDependentsQuery } from "@/App/api/member";

export const isFamilyCoverage = (): boolean => {
  const { memberEligibility } = useContext(MemberEligibilityContext);
  const { data: dependents, isLoading: isLoadingDependents } = useListMemberDependentsQuery();

  // we check coverage type and if the member has dependents to identify family coverage
  if (!isLoadingDependents) {
    return !["01", "06", "08"].includes(memberEligibility.member.coverage_type) || (dependents?.results ?? []).length > 0;
  } else {
    return true;
  }
};
